import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Research } from './components/Research';
import { News } from './components/News';
import { AIRunner } from './components/AIRunner';
import { Partners } from './components/Partners';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <About />
      <Research />
      <Partners />
      <News />
      <AIRunner />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
